import { render, staticRenderFns } from "./yiBlack.vue?vue&type=template&id=0fe08cf6&scoped=true&"
import script from "./yiBlack.vue?vue&type=script&lang=js&"
export * from "./yiBlack.vue?vue&type=script&lang=js&"
import style0 from "./yiBlack.vue?vue&type=style&index=0&id=0fe08cf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe08cf6",
  null
  
)

export default component.exports